import { Box, Button, Stack, Typography } from '@mui/material'
import CodeTag from 'src/components/CodeTag'
import CopyButton from 'src/components/CopyButton'
import Iconify from 'src/components/Iconify'
import { icons } from 'src/design-system'

/** What the saved file is called. */
export const RECOVERY_CODES_FILE = 'beast-recovery-codes.txt'

const saveAsFile = (codes: string[]) => {
  const url = URL.createObjectURL(
    new Blob(
      [
        `Beast console recovery codes. Each works once, in place of a code from your authenticator app.\n\n${codes.join(
          '\n',
        )}\n`,
      ],
      { type: 'text/plain' },
    ),
  )
  const link = document.createElement('a')
  link.href = url
  link.download = RECOVERY_CODES_FILE
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

/**
 * A new set of recovery codes, shown the one time they ever are. Copy and
 * save both, because a person reaching for one has lost the phone, and often
 * the browser session with it.
 */
export default function RecoveryCodes({ codes }: { codes: string[] }) {
  return (
    <Stack spacing={2}>
      <Typography variant="body2" color="text.secondary">
        Keep these somewhere other than your phone. Each one works once, in
        place of a code from the app, and they will not be shown again.
      </Typography>
      <Box
        component="ol"
        aria-label="Recovery codes"
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: 1,
          m: 0,
          p: 0,
          listStyle: 'none',
        }}
      >
        {codes.map((code) => (
          <li key={code}>
            <CodeTag>{code}</CodeTag>
          </li>
        ))}
      </Box>
      <Stack direction="row" spacing={1} alignItems="center">
        <CopyButton value={codes.join('\n')} label="Copy the codes" />
        <Button
          variant="outlined"
          color="inherit"
          startIcon={<Iconify icon={icons.export} size="control" />}
          onClick={() => saveAsFile(codes)}
        >
          Save as a file
        </Button>
      </Stack>
    </Stack>
  )
}
